import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountTicketsNgrxFacade, ApplicationFacade, Ticket, TicketsService } from '@ridango/components';
import { of, timer } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent, NetworkService } from '@ridango/core';
import Env from '@ridango/core/env';
import { AccountTicketsService } from '@ridango/components/lib/account-tickets-ngrx/services/account-tickets.service';
import { scrollIntoView } from 'seamless-scroll-polyfill';
import { Capacitor } from '@capacitor/core';

@Component({
    templateUrl: './ticket-qr-page.component.html',
    styleUrls: ['./ticket-qr-page.component.scss']
})
export class TicketQrPageComponent extends BaseComponent implements OnInit, OnDestroy {
    public ticket: Ticket;
    readonly assetsPath$ = this.applicationFacade.assetsPath$;
    @ViewChild('qrContainer') qrContainerEl: ElementRef;
    public hideQrCode = true;
    private qrScrollHandler;

    ticketId = this.route.snapshot.params.id;
    ticket$ = this.accountTicketsFacade.getTicket$(this.ticketId);

    constructor(
        private route: ActivatedRoute,
        private accountTicketsFacade: AccountTicketsNgrxFacade,
        private translate: TranslateService,
        private router: Router,
        @Inject('ENV') public env: Env,
        public ticketService: TicketsService,
        private applicationFacade: ApplicationFacade,
        private accountTicketService: AccountTicketsService,
        private network: NetworkService
    ) {
        super();
    }

    ngOnInit() {
        this.network.getStatus().subscribe((status) => {
            if (status) {
                this.route.paramMap
                    .pipe(
                        take(1),
                        switchMap((params) => this.accountTicketsFacade.fetchAccountTicketById(params.get('id'))),
                        catchError(() => {
                            this.router.navigate([this.translate.currentLang, 'account', 'tickets']);

                            return of(null);
                        })
                    )
                    .subscribe(async (ticket) => {
                        this.ticket = ticket;
                        const delayBeforeScroll = this.accountTicketService.showAztecCode(ticket) ? 500 : 50;
                        timer(delayBeforeScroll).subscribe(() => this.scrollToQrCode());
                    });
            } else {
                this.ticket$.subscribe((ticket) => {
                    this.ticket = ticket;
                    const delayBeforeScroll = this.accountTicketService.showAztecCode(ticket) ? 500 : 50;
                    timer(delayBeforeScroll).subscribe(() => this.scrollToQrCode());
                });
            }
        });

        this.qrScrollHandler = () => {
            timer(100).subscribe(() => this.scrollToQrCode());
        };

        screen.orientation.addEventListener('change', this.qrScrollHandler);
    }

    scrollToQrCode(): void {
        scrollIntoView(this.qrContainerEl?.nativeElement, {
            inline: 'center',
            block: 'center',
            behavior: 'smooth'
        });

        timer(450).subscribe(() => (this.hideQrCode = false));
    }

    get isIosPlatform(): boolean {
        return Capacitor.getPlatform() === 'ios';
    }

    async handleBackClicked(): Promise<void> {
        window.history.back();
    }

    ngOnDestroy() {
        screen.orientation.removeEventListener('change', this.qrScrollHandler);
    }
}
